module.exports = __webpack_public_path__ + "static/012-6794fca7be0a627dadf2f05014d89fa1.jpg";